import script from "./MainHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./MainHeader.vue?vue&type=script&lang=ts&setup=true"

import "./MainHeader.vue?vue&type=style&index=0&id=e37d296a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e37d296a"]])

export default __exports__